import React, { useState, useEffect } from "react";
import { abbreviateNumber } from "js-abbreviation-number";
import { Link } from "react-router-dom";
import slugify from "../utils/slugify";
import LazyImage from "./LazyImage";
import VideoLength from "../shared/VideoLength";
import { addToFavorites, removeFromFavorites, isFavorited } from "../utils/favorites";
import { MdBookmarkBorder, MdBookmark } from "react-icons/md";

const SuggestionVideoCard = ({ video }) => {
  const slug = slugify(video?.title || video?.videoId || "video");
  const thumbnailUrl = video?.thumbnails?.[0]?.url || `https://i.ytimg.com/vi/${video?.videoId}/hqdefault.jpg` || '/default-thumbnail.svg';
  const [favorited, setFavorited] = useState(false);

  useEffect(() => {
    const id = video?.videoId || video?.originalUrl || video?.url || null;
    if (id) setFavorited(isFavorited(id));
  }, [video]);

  const onToggleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const id = video?.videoId || video?.originalUrl || video?.url || null;
    if (!id) return;
    if (favorited) {
      removeFromFavorites(id);
      setFavorited(false);
    } else {
      addToFavorites(video);
      setFavorited(true);
    }
  };
  
  return (
    <Link to={`/${slug}`} state={{ playerVideo: video }}>
      <div className="flex mb-4">
        <div className="relative h-24 lg:h-20 xl:h-24 w-40 min-w-[168px] lg:w-32 lg:min-w-[128px] xl:w-40 xl:min-w-[168px] rounded-xl bg-slate-800 overflow-hidden">
          <LazyImage
            src={thumbnailUrl}
            alt="thumbnails"
            className="h-full w-full object-cover"
            videoUrl={video?.originalUrl || video?.thumbnails?.[0]?.url}
            videoDuration={video?.lengthSeconds}
          />
          {video?.lengthSeconds && <VideoLength time={video?.lengthSeconds} />}

          <button
            title={favorited ? 'Saved' : 'Save'}
            onClick={onToggleFavorite}
            className="absolute right-2 top-2 z-20 text-white bg-black/30 hover:bg-black/50 p-1 rounded-full"
          >
            {favorited ? <MdBookmark className="text-lg" /> : <MdBookmarkBorder className="text-lg" />}
          </button>
        </div>

        <div className="flex text-black dark:text-white">
          {/* <div className="flex items-start">
            <div className="flex h-9 w-9 rounded-full overflow-hidden">
              <img
                src={video?.author?.avatar[0]?.url}
                alt="Avatar"
                className="h-full w-full object-cover"
              />
            </div>
          </div> */}

          <div className="flex flex-col ml-3 overflow-hidden">
            <span className="text-sm md:text-base lg:text-sm font-bold line-clamp-2 whitespace-normal break-words">
              {video?.title}
            </span>

            <div className="flex text-[12px] font-semibold text-black/[0.8] dark:text-white/[0.7] truncate overflow-hidden lg:text-[12px] xl:text-[12px]">
              <span>{`${abbreviateNumber(video?.stats?.views, 2)} views`}</span>
              <span className="flex text-[24px] text-black/[0.8] dark:text-white/[0.7] font-bold leading-none relative top-[-10px] mx-1">
                .
              </span>
              <span className="truncate">{video?.publishedTimeText}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SuggestionVideoCard;
